import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import SvgIcon from "@mui/material/SvgIcon";
import Tooltip from "@mui/material/Tooltip";
import Settings03Icon from "@untitled-ui/icons-react/build/esm/Settings03";
import type { FC } from "react";
interface SettingsButtonProps {
  onClick?: () => void;
}
export const SettingsButton: FC<SettingsButtonProps> = props => <Tooltip title="Settings" data-sentry-element="Tooltip" data-sentry-component="SettingsButton" data-sentry-source-file="settings-button.tsx">
		<Box {...props} data-sentry-element="Box" data-sentry-source-file="settings-button.tsx">
			<ButtonBase sx={{
      backgroundColor: "primary.main",
      borderRadius: "50%",
      color: "primary.contrastText",
      p: "10px"
    }} data-sentry-element="ButtonBase" data-sentry-source-file="settings-button.tsx">
				<SvgIcon data-sentry-element="SvgIcon" data-sentry-source-file="settings-button.tsx">
					<Settings03Icon data-sentry-element="Settings03Icon" data-sentry-source-file="settings-button.tsx" />
				</SvgIcon>
			</ButtonBase>
		</Box>
	</Tooltip>;